module.exports = __webpack_public_path__ + "img/Camera-Icon-blue.7dc5dd97.svg";